import {Observable, race, Subject} from 'rxjs';
import {finalize, share, take, tap} from 'rxjs/operators';

export interface PendingRequest<T> {
    request$: Observable<T>;
    subject$: Subject<T>;
}

export const createPendingRequest = <T>(
    rawRequest$: Observable<T>,
    registerPendingRequest: (pendingRequest: PendingRequest<T>) => void,
    deletePendingRequest: () => void
): PendingRequest<T> => {
    const subject$ = new Subject<T>();
    const request$ = race(
        rawRequest$,
        subject$
    ).pipe(
        take(1),
        tap(deletePendingRequest),
        finalize(deletePendingRequest),
        share()
    );

    const pendingRequest: PendingRequest<T> = {
        request$,
        subject$
    };

    registerPendingRequest(pendingRequest);

    return pendingRequest;
};

export const failPendingRequest = <T>(pendingRequest: PendingRequest<T>): void => {
    pendingRequest.subject$.error(null);
    pendingRequest.subject$.complete();
};

export const failPendingRequestIfExists = <T>(pendingRequest: PendingRequest<T>): void => {
    if (pendingRequest) {
        failPendingRequest(pendingRequest);
    }
};

export const completePendingRequestIfExists = <T>(pendingRequest: PendingRequest<T>, nextValue: T): void => {
    if (pendingRequest) {
        pendingRequest.subject$.next(nextValue);
        pendingRequest.subject$.complete();
    }
};
